import { render, staticRenderFns } from "./TheCity.vue?vue&type=template&id=6f8a3cdc&scoped=true"
import script from "./TheCity.vue?vue&type=script&lang=ts"
export * from "./TheCity.vue?vue&type=script&lang=ts"
import style0 from "./TheCity.vue?vue&type=style&index=0&id=6f8a3cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a3cdc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSelectTheSelect: require('/usr/src/nuxt-app/components/core/select/TheSelect.vue').default})
